import { BCKSInvitationRevisionPage } from 'app/BCKSPage/Invitation/revision'
import { isToggleEnabled } from 'configs/toggle-feature'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'

interface PropsInvitationRevisionPage {
  isKSSelectionEnabled: boolean
}

export async function getServerSideProps() {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const BCKSInvitationRevisionIndexPage = (
  props: PropsInvitationRevisionPage
) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <BCKSInvitationRevisionPage />
}

// eslint-disable-next-line react/display-name
BCKSInvitationRevisionIndexPage.Layout = ({ children }) => children

export default BCKSInvitationRevisionIndexPage
